var _g, _circle, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoUpsells(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_13796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 31V25V22C54 18.69 51.31 16 48 16H42.78L44 17.97C44 17.97 44 17.99 44.01 18H48C49.11 18 50.1 18.45 50.83 19.17C51.56 19.9 52 20.89 52 22V24H36V26H52V30H36V32H52V44C52 45.11 51.55 46.1 50.83 46.83C50.1 47.56 49.11 48 48 48H10C8.89 48 7.9 47.55 7.17 46.83C6.44 46.1 6 45.11 6 44V32H22V30H6V26H22V24H6V22C6 20.89 6.45 19.9 7.17 19.17C7.9 18.44 8.89 18 10 18H14.06C14.06 18 14.1 17.92 14.13 17.88L15.36 16H10C6.69 16 4 18.69 4 22V44C4 47.31 6.69 50 10 50H48C51.31 50 54 47.31 54 44V31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 19.05C15.58 19.38 15.48 19.75 15.48 20.12C15.48 20.63 15.68 21.11 16.02 21.47C16.36 21.83 16.44 22.01 17 22.01H24V37.02C24 38.67 25.34 40.01 27 40.01H31C32.66 40.01 34 38.67 34 37.02V22.01H41C41.56 22.01 41.7 21.83 42.04 21.47C42.38 21.11 42.58 20.63 42.58 20.12C42.58 19.78 42.48 19.42 42.29 19.1L31.06 0.92C30.68 0.32 30.02 0 29.39 0C28.78 0 28.14 0.3 27.76 0.88L15.8 19.05ZM29.39 2.03L40.55 20.06H32V37C32 37.55 31.55 38 31 38H27C26.45 38 26 37.55 26 37V20.06H17.52L29.39 2.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 45C47.21 45 49 43.21 49 41C49 38.79 47.21 37 45 37C42.79 37 41 38.79 41 41C41 43.21 42.79 45 45 45ZM45 39C46.1 39 47 39.9 47 41C47 42.1 46.1 43 45 43C43.9 43 43 42.1 43 41C43 39.9 43.9 39 45 39Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 11,
    fill: "#25BB73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.1152,
    y: 46.8223,
    width: 1.5,
    height: 7.58759,
    rx: 0.75,
    transform: "rotate(-45 40.1152 46.8223)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.48,
    y: 52.1875,
    width: 1.5,
    height: 11.9926,
    rx: 0.75,
    transform: "rotate(-135 45.48 52.1875)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_13796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoUpsells);
export default __webpack_public_path__ + "static/media/autoUpsells.00da18d026ee3264852265ccaacc6329.svg";
export { ForwardRef as ReactComponent };